import {useCallback, useMemo} from 'react';

export const useGameActivitySetup = ({
  formData,
  handleFormChange,
  daysOfWeekList
}) => {
  const handleDailyDisplayStartTimeChange = useCallback(
    (value) => {
      handleFormChange({dailyDisplayStartTime: value});
      if (formData?.dailyDisplayEndTime && value) {
        const [startHour, startMin] = value.split(':').map(Number);
        const [endHour, endMin] = formData.dailyDisplayEndTime
          .split(':')
          .map(Number);
        const startMinutes = startHour * 60 + startMin;
        const endMinutes = endHour * 60 + endMin;
        if (endMinutes <= startMinutes) {
          handleFormChange({dailyDisplayEndTime: ''});
        }
      }
    },
    [handleFormChange, formData?.dailyDisplayEndTime]
  );

  const handleDailyDisplayEndTimeChange = useCallback(
    (value) => {
      handleFormChange({dailyDisplayEndTime: value});
    },
    [handleFormChange]
  );

  const minEndTime = useMemo(() => {
    if (!formData?.dailyDisplayStartTime) return null;
    const [hours, minutes] = formData.dailyDisplayStartTime
      .split(':')
      .map(Number);
    const totalMinutes = hours * 60 + minutes + 1;
    const newHours = Math.floor(totalMinutes / 60);
    const newMinutes = totalMinutes % 60;
    if (newHours >= 24) return '23:59';
    return `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}`;
  }, [formData?.dailyDisplayStartTime]);

  const handleDaysUnavailableChange = useCallback(
    (selected) => {
      const values = Array.isArray(selected)
        ? selected.map((item) => item?.value || item?.displayText)
        : [];
      handleFormChange({daysOfWeekUnavailable: values});
    },
    [handleFormChange]
  );

  const handleDailyPlayLimitKeyDown = useCallback((e) => {
    if (['+', '.', 'e', 'E', '-'].includes(e.key)) {
      e.preventDefault();
    }
  }, []);

  const handleDailyPlayLimitChange = useCallback(
    (value) => {
      const sanitized =
        typeof value === 'string'
          ? Number(value.replace(/[^0-9]/g, '')) || ''
          : value;
      handleFormChange({dailyPlayLimit: sanitized});
    },
    [handleFormChange]
  );

  const daysUnavailableValue = useMemo(() => {
    if (!formData?.daysOfWeekUnavailable?.length) return [];
    return daysOfWeekList.filter((item) =>
      formData.daysOfWeekUnavailable.includes(item.value)
    );
  }, [formData?.daysOfWeekUnavailable, daysOfWeekList]);

  return {
    handleDailyDisplayStartTimeChange,
    handleDailyDisplayEndTimeChange,
    minEndTime,
    handleDaysUnavailableChange,
    handleDailyPlayLimitChange,
    handleDailyPlayLimitKeyDown,
    daysUnavailableValue
  };
};
